<script setup>
import { useRoute } from 'vue-router'
import { onMounted, ref } from 'vue'

import { client } from '@/services/fetch.js'

import PollComponent from '@/components/CompiledPoll/PollComponent.vue'
import ButtonTornaAllaLista from '@/components/Generics/Buttons/ButtonTornaAllaLista.vue'
import Loading from '@/components/Generics/Loadings/Loading.vue'

const route = useRoute()
const props = defineProps(['updatePageTitle'])
const compiledPollId = route['params']['id']
let compiledPoll = ref(null)
let isLoading = ref(true)
let form = ref(null)
let networkError = ref({
  enabled: false,
  message: 'Errore nel caricamento dei dati, riprova più tardi'
})

const getCompiledPoll = async () => {
  try {
    let url = `/compiled-poll/api/compiled-poll/${compiledPollId}?poll=1`
    const response = await client.get(url)
    compiledPoll.value = response.data
    isLoading.value = false
  } catch (error) {
    networkError.value.enabled = true
    isLoading.value = false
  }
}

onMounted(async () => {
  await getCompiledPoll()
  props.updatePageTitle('Compilazione - ' + compiledPoll.value.id)
})
</script>

<template>
  <div class="container-fluid" v-if="compiledPoll">
    <div class="row">
      <div class="col-12 px-0">
        <div class="card">
          <div
            v-if="networkError.enabled"
            class="alert alert-danger mt-2"
            role="alert"
          >
            {{ networkError.message }}
          </div>

          <loading v-if="isLoading"></loading>

          <form @submit.prevent="() => {}" ref="form">
            <poll-component
              v-if="compiledPoll"
              :compiled-poll="compiledPoll"
              :handle-answer="null"
              :form="form"
            ></poll-component>
          </form>
        </div>

        <div class="d-flex mt-2 justify-content-between">
          <router-link :to="{ name: 'admin/CompiledPoll' }">
            <button-torna-alla-lista></button-torna-alla-lista>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">

:root,
:host {
  @extend :root;
}

[class*='fa-'] {
  width: 0.9rem;
}
</style>
